/**
 * h5跳转到某个导航页
 * @param {*} lng 经度
 * @param {*} lat 纬度
 * @param {*} address 所在地址名字
 */
export function jumpToAmap(lng, lat, address) {
  window.location.href = `https://uri.amap.com/marker?position=${lng},${lat}&name=${address}`
}

/**
 * 计算两个点位之间的距离
 * @param {*} point1
 * @param {*} point2
 * @param {*} map
 */
export function getDistance(point1, point2) {
  if (!point1 || !point2) {
    console.error("getDistance point1, point2 is undefined!")
    return null
  }
  var m1 = new AMap.LngLat(point1.lng, point1.lat)
  var m2 = new AMap.LngLat(point2.lng, point2.lat)
  return Number((m1.distance(m2) / 1000).toFixed(2))
}
